import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../imgs/aor_logo_branco2.png';
import fctuc from '../imgs/fctuc.png';
import dei from '../imgs/dei_logo.png';

//components
import Popup from 'reactjs-popup';
import BurgerIcon from './BurgerIcon';
import MobileMenu from './MobileMenu';

const contentstyle = {
  top: '60px !important',
  background: 'none',
  border: 'none',
  width: 'auto',
  boxShadow: 'none',
  padding: '0',
};
const Card = ({ text }) => <div className="card">{text}</div>;

export default () => (
  <nav className="navbar">
    <a href="http://www.uc.pt/" target="_blank" rel="noopener noreferrer">
      <img id="logo-fctuc" src={fctuc} alt="logo-fctuc" />
    </a>
    <a href="http://www.dei.uc.pt/" target="_blank" rel="noopener noreferrer">
      <img id="logo-dei" src={dei} alt="logo-dei" />
    </a>
    <a href="">
      <img id="logo-course" src={logo} alt="logo-course" />
    </a>

    <Popup
      trigger={
        <span className="big-text hover under hide-mob" id="bachelors">
          <p> Licenciaturas</p>
        </span>
      }
      position="bottom left"
      on="hover"
      contentStyle={contentstyle}
    >
      <Card
        text={
          <div>
            —
            <div>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/ldm" target="_blank" rel="noopener noreferrer">
                  Design e Multimédia
                </a>
              </p>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/lecd" target="_blank" rel="noopener noreferrer">
                  Engenharia e Ciência de Dados
                </a>
              </p>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/lei" target="_blank" rel="noopener noreferrer">
                  Engenharia Informática
                </a>
              </p>
            </div>
          </div>
        }
      />
    </Popup>

    <Popup
      trigger={
        <span className="big-text hover under hide-mob" id="masters">
          <p> Mestrados</p>
        </span>
      }
      position="bottom left"
      on="hover"
      contentStyle={contentstyle}
    >
      <Card
        text={
          <div>
            —
            <div>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/mdm" target="_blank" rel="noopener noreferrer">
                  Design e Multimédia
                </a>
              </p>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/mse" target="_blank" rel="noopener noreferrer">
                  Engenharia de Software
                </a>
              </p>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/mecd" target="_blank" rel="noopener noreferrer">
                  Engenharia e Ciência de Dados
                </a>
              </p>
              <p className="normal-text">
                <a href="http://www.dei.uc.pt/mei" target="_blank" rel="noopener noreferrer">
                  Engenharia Informática
                </a>
              </p>

              <p className="normal-text">
                <a href="http://www.dei.uc.pt/msi" target="_blank" rel="noopener noreferrer">
                  Segurança Informática
                </a>
              </p>
            </div>
          </div>
        }
      />
    </Popup>

    <Popup
      trigger={
        <span className="big-text hover under hide-mob" id="phds">
          <p> Doutoramentos</p>
        </span>
      }
      position="bottom left"
      on="hover"
      contentStyle={contentstyle}
    >
      <Card
        text={
          <div>
            —
            <p className="normal-text">
              <a href="http://www.dei.uc.pt/pdcti/" target="_blank" rel="noopener noreferrer">
                Ciências e Tecnologias da Informação
              </a>
            </p>
          </div>
        }
      />
    </Popup>

    <Popup
      trigger={
        <span className="big-text hover under hide-mob" id="phds">
          <p>Formação Avançada</p>
        </span>
      }
      position="bottom left"
      on="hover"
      contentStyle={contentstyle}
    >
      <Card
        text={
          <div>
            <p className="normal-text">Não conferente de grau</p>—
            <p className="normal-text">
              <a href="https://acertarorumo.pt/" target="_blank" rel="noopener noreferrer">
                Acertar o Rumo
              </a>
            </p>
            <p className="normal-text">
              <a href="https://dei.uc.pt/pc1/" target="_blank" rel="noopener noreferrer">
                Programação Competitiva I
              </a>
            </p>
          </div>
        }
      />
    </Popup>

    <Popup
      modal
      lockScroll
      overlayStyle={{ background: '#0096d7', top: '60px' }}
      contentStyle={{
        width: '100%',
        margin: '0',
        paddingTop: '20px',
        paddingLeft: '20px',
        background: 'none',
        border: 'none',
        color: 'white',
      }}
      closeOnDocumentClick={false}
      trigger={(open) => <BurgerIcon open={open} />}
    >
      {(close) => <MobileMenu close={close} />}
    </Popup>
  </nav>
  // <nav className="navbar">
  //   <span className="hover" id="fctuc">
  //     <a href="http://www.uc.pt/" target="_blank" rel="noopener noreferrer">
  //       <img src={fctuc} alt="FCTUC" />
  //     </a>
  //   </span>

  //   <span className="hover" id="dei">
  //     <a href="https://www.uc.pt/fctuc/dei/" target="_blank" rel="noopener noreferrer">
  //       <img src={dei} alt="DEI" />
  //     </a>
  //   </span>

  //   <span className="hover" id="acertar">
  //     <Link to="/">
  //       <img src={logo} alt="AOR" />
  //     </Link>
  //   </span>

  //   <span className="normal-text hover under hide-mob" id="estrutura">
  //     <Link to="/estrutura-do-curso">Estrutura do Curso</Link>
  //   </span>

  //   <span className="normal-text hover under hide-mob" id="selecao">
  //     <Link to="/selecao-de-formandos">Seleção de Formandos</Link>
  //   </span>

  //   <span className="normal-text hover under hide-mob" id="empresas">
  //     <Link to="/empresas-aderentes">Empresas Aderentes</Link>
  //   </span>

  //   <span className="normal-text hover under hide-mob" id="lideres">
  //     <Link to="/testemunhos">Testemunhos</Link>
  //   </span>

  //   <Popup
  //     modal
  //     lockScroll
  //     overlayStyle={{ background: '#0096d7', top: '60px' }}
  //     contentStyle={{
  //       width: '100%',
  //       margin: '0',
  //       paddingTop: '20px',
  //       paddingLeft: '20px',
  //       background: 'none',
  //       border: 'none',
  //       color: 'white',
  //     }}
  //     closeOnDocumentClick={false}
  //     trigger={(open) => <BurgerIcon open={open} />}
  //   >
  //     {(close) => <MobileMenu close={close} />}
  //   </Popup>
  // </nav>
);
